<template>
  <FormContainer
    level="section"
    class="form-container--section"
    button-text="continuer"
    :title="sectionTitle"
    @click="$emit('continue')"
  >
    <ThemeCard
      v-for="[themeKey, theme] of themes"
      :key="`theme-${themeKey}`"
      :class="themeKey === 1 ? 'mt-5' : null"
      :theme="theme"
      :is-selected="isThemeSelected(theme)"
    />
  </FormContainer>
</template>

<script>
import FormContainer from './FormContainer.vue'
import ThemeCard from './ThemeCard.vue'
export default {
  components: { FormContainer, ThemeCard },
  props: {
    section: {
      type: Object,
      required: true,
    },
    selectedTheme: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    sectionTitle() {
      return `${this.section.section_number} ${this.section.name}`
    },
    themes() {
      return this.section.themes.reduce((map, theme) => {
        return map.set(theme.display_order, theme)
      }, new Map())
    },
  },
  methods: {
    isThemeSelected(theme) {
      return theme.display_order === this.selectedTheme
    },
  },
}
</script>
<style lang="scss" >
.form-container--section > .card-top-tab {
  position: relative;
  &:after {
    display: block;
    content: '';
    mask: url('../../../images/arrow.svg') no-repeat 100% 100%;
    mask-size: contain;
    background-color: var(--bs-secondary);
    position: absolute;
    right: 3%;
    --IMG_SIZE: 30%;
    bottom: calc(-1 * var(--IMG_SIZE));
    height: var(--IMG_SIZE);
    width: var(--IMG_SIZE);
  }
}
</style>
